var map = {
	"./about-us-banner-cn.webp": 1534,
	"./about-us-banner-m-cn.webp": 1535,
	"./about-us-banner-m-ms.webp": 1536,
	"./about-us-banner-m.webp": 1537,
	"./about-us-banner-ms.webp": 1538,
	"./about-us-banner.webp": 465,
	"./banner-01.jpg": 1539,
	"./banner-slot.jpg": 1540,
	"./bet-and-earn-banner-cn.webp": 1541,
	"./bet-and-earn-banner-indon.webp": 1542,
	"./bet-and-earn-banner-ms.webp": 1543,
	"./bet-and-earn-banner.webp": 1544,
	"./check-in-banner-cn.webp": 1545,
	"./check-in-banner-id.webp": 1546,
	"./check-in-banner-ms.webp": 1547,
	"./check-in-banner.webp": 1548,
	"./cny_2024-bm.webp": 1549,
	"./cny_2024-cn.webp": 1550,
	"./cny_2024.webp": 1551,
	"./epl-banner-cn.webp": 1552,
	"./epl-banner-indo.webp": 1553,
	"./epl-banner-ms.webp": 1554,
	"./epl-banner.webp": 1555,
	"./games-banners-cn.webp": 1556,
	"./games-banners-ms.webp": 1557,
	"./games-banners.webp": 1558,
	"./lb-m-banner-cn.webp": 1559,
	"./lb-m-banner.webp": 1560,
	"./leaderboard-banner-cn.webp": 1561,
	"./leaderboard-banner.webp": 1562,
	"./lottery-banner.webp": 1563,
	"./lottery-banners-cn.webp": 1564,
	"./lottery-banners-ms.webp": 1565,
	"./lottery-banners.webp": 1566,
	"./lucky-spin-banner-cn.webp": 1567,
	"./lucky-spin-banner-ms.webp": 1568,
	"./lucky-spin-banner.webp": 1569,
	"./p2p-banner.webp": 1570,
	"./p2p-banners-cn.webp": 1571,
	"./p2p-banners-ms.webp": 1572,
	"./p2p-banners.webp": 1573,
	"./premier-league-banner-cn.webp": 1574,
	"./premier-league-banner.webp": 1575,
	"./promo-vip-banner-cn.webp": 1576,
	"./promo-vip-banner-ms.webp": 1577,
	"./promo-vip-banner.webp": 1578,
	"./promos-banner-cn.webp": 1579,
	"./promos-banner-indon.webp": 1580,
	"./promos-banner-ms.webp": 1581,
	"./promos-banner.webp": 1582,
	"./promos-detail-banner.jpg": 1583,
	"./side-bar-banner.jpg": 1584,
	"./slot-banners-cn.webp": 1585,
	"./slot-banners-ms.webp": 1586,
	"./slot-banners.webp": 1587,
	"./speed-banners-cn.webp": 1588,
	"./speed-banners-ms.webp": 1589,
	"./speed-banners.webp": 1590,
	"./vip-banner-cn.webp": 1591,
	"./vip-banner-id.webp": 1592,
	"./vip-banner-m-cn.webp": 1593,
	"./vip-banner-m-ms.webp": 1594,
	"./vip-banner-m.webp": 1595,
	"./vip-banner-ms.webp": 1596,
	"./vip-banner.webp": 1597,
	"./vip-deposit-marathon-challenges-cn.webp": 1598,
	"./vip-deposit-marathon-challenges-ms.webp": 1599,
	"./vip-deposit-marathon-challenges.webp": 1600,
	"./winner-leaderboard-banner-cn.webp": 1601,
	"./winner-leaderboard-banner.webp": 1602,
	"./world-cup-banner-cn.webp": 1603,
	"./world-cup-banner.webp": 1604,
	"./world-cup-two-banner-cn.webp": 1605,
	"./world-cup-two-banner.webp": 1606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;